// @ts-nocheck
import * as Types from '../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../fragments/commonFragments.generated';
export type BidContractOverview_RevisionFragment = { __typename?: 'BidContractRevision', id: string, planBasedLineItems: Array<{ __typename?: 'PlanBasedBidContractLineItem', id: string, totalCostInCents: number, groupLine: { __typename?: 'BidPlanChildGroupLine', id: string, group: { __typename?: 'BidPlanChildGroup', id: string, productOffering: { __typename?: 'ProductOffering', id: string, name: string } } } }> };

export const BidContractOverview_RevisionFragmentDoc = gql`
    fragment BidContractOverview_Revision on BidContractRevision {
  id
  planBasedLineItems {
    id
    totalCostInCents
    groupLine {
      id
      group {
        id
        productOffering {
          ...Named
        }
      }
    }
  }
}
    ${NamedFragmentDoc}`;